import { ActionType } from '../constants/ActionTypes'

export default function freeSpinsReducer(state = {}, action = {}) {
    switch (action.type) {
        case ActionType.GET_FREE_SPINS_BEGIN:
            return {
                ...state,
                loading:true,
                freeSpinsObj: {},
            }
        case ActionType.GET_FREE_SPINS_ERROR:
            return {
                ...state,
                loading:false,
             }
        case ActionType.GET_FREE_SPINS_SUCCESS:
            return {
                ...state,
                freeSpinsObj: action.payload,
                loading:false,
            }

        case ActionType.GET_FREE_SPINS_GAMES_BEGIN:
            return {
                ...state,
                isGameLoading:true,
                gameList : []
            }
        case ActionType.GET_FREE_SPINS_GAMES_ERROR:
            return {
                ...state,
                isGameLoading:false,
                }
        case ActionType.GET_FREE_SPINS_GAMES_SUCCESS:
            return {
                ...state,
                gameList: action.payload,
                isGameLoading:false,
            }
        default:
            return state;
    }
}